import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { ReportBusinessAdverseMedia } from 'dashboard/models/report/business-adverse-media';

interface BusinessAdverseMediaProps {
  report: ReportBusinessAdverseMedia;
  isRedacted: boolean;
}

export const BusinessAdverseMedia = ({
  report: {
    attributes: { term, 'country-code': countryCode },
  },
  isRedacted,
}: BusinessAdverseMediaProps) => {
  return (
    <AttributeGrid>
      <AttributeItem title='Search term' value={term} placeholder='N/A' isRedacted={isRedacted} />
      <AttributeItem
        title='Country code'
        value={countryCode}
        placeholder='N/A'
        isRedacted={isRedacted}
      />
    </AttributeGrid>
  );
};
